var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OverlayTemplate',_vm._b({attrs:{"config":_vm.templates},on:{"add":_vm.addResult,"close":function($event){return _vm.$emit('close', $event)}}},'OverlayTemplate',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }